import { Color } from '../../../enums/color'
import { BadgeColor, BadgeMode, ColorStyles } from '../types/colorStyles'

export const primaryStyles: Record<BadgeColor, ColorStyles> = {
  accent: { bgColor: Color.Lavender600, textColor: Color.White },
  danger: { bgColor: Color.Red700, textColor: Color.White },
  neutral: { bgColor: Color.Grey600, textColor: Color.White },
  success: { bgColor: Color.Green500, textColor: Color.White },
  warning: { bgColor: Color.Yellow400, textColor: Color.Black },
}

export const primaryOnColorStyles: Record<BadgeColor, ColorStyles> = {
  accent: { bgColor: Color.Lavender600, textColor: Color.White },
  danger: { bgColor: Color.Red700, textColor: Color.White },
  neutral: { bgColor: Color.Grey950, textColor: Color.White },
  success: { bgColor: Color.Green800, textColor: Color.White },
  warning: { bgColor: Color.Yellow500, textColor: Color.Yellow950 },
}

export const subtleStyles: Record<BadgeColor, ColorStyles> = {
  accent: { bgColor: Color.Lavender100, textColor: Color.Lavender600 },
  danger: { bgColor: Color.Red100, textColor: Color.Red700 },
  neutral: { bgColor: Color.Grey50, textColor: Color.Grey800 },
  success: { bgColor: Color.Green100, textColor: Color.Green700 },
  warning: { bgColor: Color.Yellow100, textColor: Color.Yellow950 },
}

export const subtleOnColorStyles: Record<BadgeColor, ColorStyles> = {
  accent: { bgColor: Color.Lavender100, textColor: Color.Lavender700 },
  danger: { bgColor: Color.Red100, textColor: Color.Red800 },
  neutral: { bgColor: Color.Grey200, textColor: Color.Grey800 },
  success: { bgColor: Color.Green100, textColor: Color.Green950 },
  warning: { bgColor: Color.Yellow100, textColor: Color.Yellow950 },
}

export const disabledStyles: Record<BadgeMode, Record<'default' | 'onColor', ColorStyles>> = {
  primary: {
    default: { bgColor: Color.Grey100, textColor: Color.Grey400 },
    onColor: { bgColor: Color.Grey100, textColor: Color.Grey400 },
  },
  subtle: {
    default: { bgColor: Color.Grey50, textColor: Color.Grey400 },
    onColor: { bgColor: Color.Grey100, textColor: Color.Grey400 },
  },
}
